import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { OrthomolIcon } from '~/components-common/OrthomolIcon';
import { URLS } from '~/components-shop/Urls';
import { getCookie } from '~/components-shop/utils/cookieStorage';

/**
 * Shows a hint on the Shopware cart page when the user has items in their Prämienshop cart.
 * Reads the praemienshop-cart-count cookie (set by MeinOrthomolTreuebonusController).
 */
export const PraemienshopCartHint = () => {
  const [praemienshopCartCount, setPraemienshopCartCount] = useState(0);

  useEffect(() => {
    const cookieValue = getCookie('praemienshop-cart-count');
    if (cookieValue) {
      const count = parseInt(cookieValue, 10);
      if (!isNaN(count) && count > 0) {
        setPraemienshopCartCount(count);
      }
    }
  }, []);

  if (praemienshopCartCount === 0) {
    return null;
  }

  return (
    <div id="praemienshop-cart-hint" className="alert alert-info text-center mb-4" role="alert">
      <p className="mb-2">
        <strong>Du hast Prämien in Deinem Warenkorb</strong>
      </p>
      <a
        href={URLS.praemienshopCheckout}
        className="btn btn-textbutton btn-textbutton-small text-primary btn--has-icon"
      >
        <span>Zum Prämienshop</span>
        <div className="icon">
          <OrthomolIcon name="arrow-24" size="24" />
        </div>
      </a>
    </div>
  );
};
